import styled from 'styled-components';

export const StyledGoBackButton = styled.a`
  align-items: center;
  appearance: none;
  background-color: transparent;
  border: 0;
  color: ${props =>
    props.theme.themeColors.controlBar.leftPanel.goBackButtonColor};
  display: inline-flex;
  font-family: inherit;
  font-size: 1rem;
  margin: 0 1em 0;
  padding: 0;
  text-decoration: none;
  > svg {
    margin-right: 0.5em;
  }

  &:hover {
    color: ${props =>
      props.theme.themeColors.controlBar.leftPanel.goBackButtonColorOnHover};

    > svg {
      path {
        stroke: ${props =>
          props.theme.themeColors.controlBar.leftPanel
            .goBackButtonColorOnHover};
      }
    }
  }

  &:active {
    color: ${props =>
      props.theme.themeColors.controlBar.leftPanel.goBackButtonColorOnActive};

    > svg {
      path {
        stroke: ${props =>
          props.theme.themeColors.controlBar.leftPanel
            .goBackButtonColorOnActive};
      }
    }
  }
  @media all and (max-width: 1200px) {
    & > span {
      display: none;
    }
    margin: 0 0 0 15px;
  }
`;
